// language-utils.js
import translations from "@/utils/transilator.json";

// Default language
const DEFAULT_LANGUAGE = "en";

// Available languages
export const AVAILABLE_LANGUAGES = {
  en: {
    name: "English",
    dir: "ltr",
    flag: "🇺🇸",
  },
  ar: {
    name: "العربية",
    dir: "rtl",
    flag: "🇦🇪",
  },
};

// Get the current language from localStorage
export const getCurrentLanguage = () => {
  try {
    const savedLanguage = localStorage.getItem("appLanguage");
    return savedLanguage && AVAILABLE_LANGUAGES[savedLanguage]
      ? savedLanguage
      : DEFAULT_LANGUAGE;
  } catch (error) {
    console.error("Error getting language from localStorage:", error);
    return DEFAULT_LANGUAGE;
  }
};

// Set the language in localStorage
export const setLanguage = (languageCode) => {
  try {
    if (AVAILABLE_LANGUAGES[languageCode]) {
      localStorage.setItem("appLanguage", languageCode);
      document.documentElement.dir = AVAILABLE_LANGUAGES[languageCode].dir;
      document.documentElement.lang = languageCode;
      window.dispatchEvent(new Event("languagechange"));

      return true;
    }
    return false;
  } catch (error) {
    console.error("Error setting language in localStorage:", error);
    return false;
  }
};

// Initialize language settings on app load
export const initializeLanguage = () => {
  const currentLang = getCurrentLanguage();
  setLanguage(currentLang);
  return currentLang;
};

// Get translated text for a key
export const t = (key) => {
  const currentLang = getCurrentLanguage();

  try {
    // Navigate through nested keys (e.g., "header.title")
    const keyPath = key.split(".");
    let value = translations;

    for (const k of keyPath) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Key not found
        return key;
      }
    }

    if (value && value[currentLang]) {
      return value[currentLang];
    }

    // Fallback to English if translation not available
    if (value && value[DEFAULT_LANGUAGE]) {
      return value[DEFAULT_LANGUAGE];
    }

    // Return the key if no translation found
    return key;
  } catch (error) {
    console.error(`Error getting translation for key: ${key}`, error);
    return key;
  }
};

// Format date according to the current language
export const formatDate = (date) => {
  const currentLang = getCurrentLanguage();
  try {
    return new Date(date).toLocaleDateString(
      currentLang === "ar" ? "ar-AE" : "en-US"
    );
  } catch (error) {
    console.error("Error formatting date:", error);
    return date;
  }
};
